// extracted by mini-css-extract-plugin
export default {"stack":"AvatarGroup--stack--Fjmjm","noStack":"AvatarGroup--noStack--SRkXe","stackAvatar":"AvatarGroup--stackAvatar--tiDG-"};